import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 col-xl-6 col-xm-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "border p-2 p-lg-4 border-dark border-opacity-10" }
const _hoisted_6 = { class: "mb-15 mb-md-20" }
const _hoisted_7 = { class: "mb-15 mb-md-20" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "mb-15 mb-md-20" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = {
  key: 0,
  class: "mb-15 mb-md-20"
}
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "mb-15 mb-md-20" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "card-footer p-15 p-sm-20 p-md-25 p-lg-30 bg-white" }
const _hoisted_18 = {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}
const _hoisted_19 = {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "button",
  disabled: ""
}
const _hoisted_20 = { class: "col-md-6 col-xl-6 col-xm-12" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_22 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_23 = { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }
const _hoisted_24 = { class: "card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5" }
const _hoisted_25 = { class: "fw-medium text-muted me-8" }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-semibold text-dark" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-semibold text-dark" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_33 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          ref: "redeForm",
          onSubmit: _ctx.payer,
          "validation-schema": _ctx.contratSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "card-title fw-bold mb-15 mb-lg-20 mb-xl-25" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", {
                    for: "contrat",
                    class: "form-label fw-medium text-black"
                  }, [
                    _createTextVNode(" Contrat / Usager "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "contrat",
                    modelValue: _ctx.contrat,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contrat) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, {
                        "filter-results": false,
                        "min-chars": 2,
                        "resolve-on-load": false,
                        delay: 0,
                        searchable: true,
                        "options-limit": 300,
                        options: async (query) => {
                      if (query.length >= 3) {
                        const results = await _ctx.reupererContrat(query);
                        if (results && results.length > 0) {
                          return results;
                        } else {
                          return [
                            { value: '', label: 'Aucun enregistrement trouvé' },
                          ];
                        }
                      } else {
                        return [];
                      }
                    }
                      ,
                        noOptionsText: "Tapez au moins deux caractères",
                        placeholder: "Rechercher un contrat"
                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "contrat",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                      _createTextVNode(" Impayés "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "impaye",
                      modelValue: _ctx.impp,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.impp) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.impayeOptions,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un impayé" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "impaye",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                      _createTextVNode(" Mode de paiement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "mode",
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mode) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.modes,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un mode" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "mode",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.showTransactionIdField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                          _createTextVNode(" Référence externe "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "transactionId",
                          modelValue: _ctx.transactionId,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.transactionId) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer l'ID de transaction"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "transactionId",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", {
                        for: "mois",
                        class: "form-label fw-medium text-black"
                      }, [
                        _createTextVNode(" Nombre de mois "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "mois",
                        modelValue: _ctx.mois,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mois) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        onKeydown: _cache[5] || (_cache[5] = ($event: any) => (($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault())),
                        min: "1"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "mois",
                        class: "text-danger"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", {
                        for: "montant",
                        class: "form-label fw-medium text-black"
                      }, [
                        _createTextVNode(" Montant "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "montant",
                        modelValue: _ctx.montant,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.montant) = $event)),
                        disabled: true,
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "montant",
                        class: "text-danger"
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("button", _hoisted_18, " Payer ", 512), [
                [_vShow, _ctx.valideEtape1]
              ]),
              _withDirectives(_createElementVNode("button", _hoisted_19, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))], 512), [
                [_vShow, !_ctx.valideEtape1]
              ]),
              _createVNode(_component_router_link, {
                to: "/liste-paiement",
                class: "btn btn-danger transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                  _createElementVNode("span", { class: "position-relative" }, null, -1),
                  _createTextVNode("Annuler ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Les impayés", -1)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, "TOTAL IMPAYE : " + _toDisplayString(_ctx.somRedevance), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("table", _hoisted_27, [
              _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }, " # "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Année "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Loyer "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Nmbre Mois "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Etat ")
                ])
              ], -1)),
              (_ctx.impayes)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.impayes, (imp, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: "clickable-row"
                      }, [
                        _createElementVNode("th", _hoisted_29, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(imp.annee), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(imp.taux), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(imp.mois), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary" }, [
                          _createElementVNode("span", { class: "badge text-outline-danger" }, "En attente")
                        ], -1))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_33, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "shadow-none lh-1 fw-bold ps-0",
                        colspan: "4"
                      }, " AUCUNE IMPAYE TROUVE ")
                    ], -1)
                  ]))]))
            ])
          ])
        ])
      ])
    ])
  ]))
}